import { intoResult } from '@app/packages/Result/Result'

import { ApiError, asInternalApiErrorResponse, RequestError } from './errors'

/**
 * Reads a failed response the way the api package does: our own server answers with the error
 * envelope, so keep it on the error — that is what tells a caller (and the user) what went wrong.
 * Anything else means the failure came from somewhere other than the internal api.
 */
export async function assertResponseHasNoError(resp: Response, method: string, endpoint: string) {
  if (resp.ok) return
  const text = await resp.text()
  const message = `${method} ${endpoint} call failed`

  if (!text) throw RequestError.create(resp.status, message, 'Missing response text')

  const data = intoResult(() => JSON.parse(text))
  if (data.error) throw RequestError.create(resp.status, message, text)

  const envelope = asInternalApiErrorResponse(data.value)
  if (!envelope) throw RequestError.create(resp.status, message, text)

  throw ApiError.create(resp.status, message, envelope)
}
